import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProgramTypesGUID } from '../../../models/_enum-collections';
import { ProgramSharedService } from '../../common/program-shared.service';
import { CommonSharedModule } from '../../common/shared.module';
import { PoeDocumentModel } from '../../../models/poe-document.model';
import { EngagementReviewTableComponent } from '../../shared/engagement-review-table/engagement-review-table.component';
import { EventDashboardService } from '../../services/event-dashboard.service';

@Component({
  selector: 'app-poe-documents',
  templateUrl: './poe-documents.component.html',
  styleUrls: ['./poe-documents.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, EngagementReviewTableComponent]
})
export class PoeDocumentsComponent implements OnInit {
  poeDocumentList!: PoeDocumentModel[];
  poeDocumentForm!: FormGroup;
  isdocumentSelected = false;
  documentSelected!: PoeDocumentModel;
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private eventsDashboard: EventDashboardService,
    private programSharedService: ProgramSharedService
  ) {}

  ngOnInit() {
    this.onFromGroup();
    this.setPoeDocumentList();
  }

  onFromGroup() {
    this.poeDocumentForm = this.formBuilder.group({
      poeDocument: []
    });
  }

  onpoeDocumentSelect() {
    this.documentSelected = this.poeDocumentForm.controls['poeDocument'].value;
    this.isdocumentSelected =
      !!this.poeDocumentForm.controls['poeDocument'].value;
    this.programSharedService.setReviewPoeDocumentId(this.documentSelected.id);
  }

  setPoeDocumentList() {
    this.loading = true;
    this.eventsDashboard
      .getPoeDocuments(ProgramTypesGUID.MRPP)
      .subscribe(result => {
        this.poeDocumentList = result.filter(x => x.isMandatory == true);
        const selectedDocumentId =
          this.programSharedService.getReviewPoeDocumentId();
        if (selectedDocumentId != null) {
          this.poeDocumentForm.controls['poeDocument'].setValue(
            this.poeDocumentList.find(x => x.id == selectedDocumentId)
          );
          this.documentSelected =
            this.poeDocumentForm.controls['poeDocument'].value;
          this.isdocumentSelected =
            !!this.poeDocumentForm.controls['poeDocument'].value;
        }
        this.loading = false;
      });
  }
}
